<mat-radio-group [formControl]="control" class="radio-group">
  <mat-radio-button
    *ngFor="let option of options"
    [value]="option.value"
    >{{ option.name }}</mat-radio-button
  >
</mat-radio-group>
